import type { ReactNode } from 'react';
import { ClerkProvider } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import { clerkAppearance } from '@/lib/clerkAppearance';
import { playClawOrigin } from '@/lib/redirects';

type ClerkProviderWithRouterProps = {
  children: ReactNode;
};

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!publishableKey) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY');
}

const ClerkProviderWithRouter = ({ children }: ClerkProviderWithRouterProps) => {
  const navigate = useNavigate();
  const handleRouterPush = (to: string) => navigate(to);
  const handleRouterReplace = (to: string) => navigate(to, { replace: true });

  return (
    <ClerkProvider
      appearance={clerkAppearance}
      publishableKey={publishableKey}
      routerPush={handleRouterPush}
      routerReplace={handleRouterReplace}
      allowedRedirectOrigins={[playClawOrigin]}
    >
      {children}
    </ClerkProvider>
  );
};

export default ClerkProviderWithRouter;
